import React from 'react'
import { Card, Alert, Badge } from 'react-bootstrap'
import ItemsEditor from 'components/ItemsEditor'
import { formatNumberForDisplay } from 'utils/numberUtils'
import './ItemsTab.css'

function ItemsTab({
	items = [],
	itemsModificados = { items: [], eliminarItemsIds: [] },
	onItemsChange,
	disabled = false,
	showPaymentWarning = false,
	modo = 'editar', // 'editar' | 'nuevo'
	totales = { subtotal: 0, cantidadItems: 0, total: 0 } // Recibir totales del hook
}) {

	// Usar los totales que vienen del hook (única fuente de verdad)
	const estadisticas = {
		totalItems: totales.cantidadProductos || 0,
		cantidadTotal: totales.cantidadItems || 0,
		subtotal: totales.subtotal || 0
	}

	const formatearPrecio = (precio) => {
		if (!precio || precio === 0) return "₲ 0"
		return `₲ ${formatNumberForDisplay(precio.toString())}`
	}

	return (
		<div className="items-tab">
			{/* Header con estadísticas */}
			<Card className="shadow-sm mb-3">
				<Card.Header className="bg-light">
					<div className="d-flex justify-content-between align-items-center">
						<h6 className="mb-0">
							<i className="fa fa-shopping-cart me-2"></i>
							Items del Pedido
							{showPaymentWarning && (
								<i className="fa fa-exclamation-triangle ms-2 text-warning" title="Cambios pueden afectar el total"></i>
							)}
						</h6>
						<div className="items-estadisticas">
							<Badge bg="primary" className="me-2">
								{estadisticas.totalItems} {estadisticas.totalItems === 1 ? 'producto' : 'productos'}
							</Badge>
							<Badge bg="info" className="me-2">
								{estadisticas.cantidadTotal} {estadisticas.cantidadTotal === 1 ? 'unidad' : 'unidades'}
							</Badge>
							<Badge bg="success">
								{formatearPrecio(estadisticas.subtotal)}
							</Badge>
						</div>
					</div>
				</Card.Header>
			</Card>

			{/* Advertencia para pedidos pagados */}
			{showPaymentWarning && (
				<Alert variant="warning" className="mb-3">
					<i className="fa fa-exclamation-triangle me-2"></i>
					<strong>Pedido pagado:</strong> Al modificar los items del pedido, el total puede verse afectado.
					¿Está seguro que desea continuar? Podrá gestionar el pago/devolución por fuera de la plataforma.
				</Alert>
			)}

			{/* Información contextual según el modo */}
			{modo === 'nuevo' && items.length === 0 && (
				<Alert variant="info" className="mb-3">
					<i className="fa fa-info-circle me-2"></i>
					<strong>Nuevo pedido:</strong> Agregue los productos que el cliente desea comprar.
					Puede buscar por nombre, código o categoría.
				</Alert>
			)}

			{modo === 'editar' && items.length === 0 && (
				<Alert variant="warning" className="mb-3">
					<i className="fa fa-exclamation-triangle me-2"></i>
					<strong>Sin items:</strong> Este pedido no tiene productos asignados.
					Agregue items para completar el pedido.
				</Alert>
			)}

			{/* Editor de items */}
			<Card className="shadow-sm">
				<Card.Body className="p-0">
					<ItemsEditor
						items={items}
						onItemsChange={onItemsChange}
						disabled={disabled}
						showPaymentWarning={showPaymentWarning}
					/>
				</Card.Body>
			</Card>



			{/* Tips de uso */}
			{modo === 'nuevo' && (
				<Card className="shadow-sm mt-3 items-tips">
					<Card.Body>
						<h6 className="mb-2">
							<i className="fa fa-lightbulb me-2 text-warning"></i>
							Consejos:
						</h6>
						<ul className="mb-0">
							<li>Use el buscador para encontrar productos rápidamente</li>
							<li>Puede ajustar cantidades directamente en la tabla</li>
							<li>Los precios se actualizan automáticamente</li>
							<li>Verifique el stock disponible antes de agregar grandes cantidades</li>
						</ul>
					</Card.Body>
				</Card>
			)}
		</div>
	)
}

export default ItemsTab